"use client";

/**
 * Reports, once per document, the lead a landing-page CTA click handed across
 * its hard navigation (see `fireLeadConversion` in `./conversions`).
 *
 * Mounted by `RootDocument` beside `AdPixelScripts`, so every page a CTA can
 * land on (`/sign-up`, `/app/record`) has it. A root layout mounts once per
 * document; a client-side navigation does not remount it, which is what keeps
 * this to one call per document.
 */
import { useEffect } from "react";

import { deliverHandedOffLead } from "./conversions";

/**
 * Deliver a handed-off lead on mount.
 *
 * @returns nothing; it renders no UI.
 */
export function LeadHandoffDelivery(): null {
  useEffect(() => {
    deliverHandedOffLead();
  }, []);
  return null;
}
